import React, { useState } from "react";
import Slider from "react-slick";

import "./realizations-slider.scss";

const RealizationsSlider = ({ images, center }) => {
	const [currentSlide, setCurrentSlide] = useState(0);

	const realizationsSliderOptions = {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: images?.length > 2,
		autoplay: images?.length > 2,
		autoplaySpeed: 5000,
		speed: 500,
		fade: true,
		pauseOnHover: false,
		beforeChange: function (currentSlide, nextSlide) {},
		afterChange: function (index) {
			setCurrentSlide(index);
		},
		responsive: [
			{
				breakpoint: 1201,
				settings: {},
			},
			{
				breakpoint: 992,
				settings: {},
			},
			{
				breakpoint: 769,
				settings: {},
			},
			{
				breakpoint: 576,
				settings: {},
			},
		],
	};

	const realizationsSliderCenterOptions = {
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 500,
		fade: false,
		pauseOnHover: false,
		beforeChange: function (currentSlide, nextSlide) {},
		afterChange: function (index) {
			setCurrentSlide(index);
		},
		responsive: [
			{
				breakpoint: 1201,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};

	const isCenter = center
		? { ...realizationsSliderCenterOptions }
		: { ...realizationsSliderOptions };

	return (
		<div className="realizations-slider">
			<Slider {...isCenter}>
				{images?.map((item, index) => {
					return (
						<div
							className={
								center
									? "realizations-slider__slide realizations-slider__slide--gutters"
									: "realizations-slider__slide"
							}
							key={index}
						>
							<img
								src={item.sourceUrl}
								alt={item.altText ? item.altText : ""}
								className={
									center
										? "img-fluid realizations-slider__image realizations-slider__image--center"
										: "img-fluid realizations-slider__image"
								}
							/>
						</div>
					);
				})}
			</Slider>
			{images?.length > 2 && images?.length > isCenter.slidesToShow && (
				<div
					className={
						center
							? "realizations-slider__nav realizations-slider__nav--center"
							: "realizations-slider__nav"
					}
				>
					{currentSlide + 1}{" "}
					<span className="realizations-slider__nav-separator" />
					{images?.length}
				</div>
			)}
		</div>
	);
};

export default RealizationsSlider;
